module.exports = __webpack_public_path__ + "static/media/5849979141644827218deluxe.4fd69af3.jpg";